import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthorizedEntityService } from '@app/features/authorized-entity/services/authorized-entity.service';
import { AuthorizedEntityDTO } from '../models/authorized-entity.model';


export const authorizedEntityResolver: ResolveFn<AuthorizedEntityDTO | null> = (
    route: ActivatedRouteSnapshot
) => {
    const authorizedEntityService = inject(AuthorizedEntityService);
    const router = inject(Router)
    const uuid = route.paramMap.get('uuid');

    if (!uuid) {
        return of(null);
    }

    return authorizedEntityService.getAuthorizedEntity(uuid).pipe(
        catchError((error) => {
            console.error('Błąd pobierania Podmiotu:', error);
            router.navigate(['/authorized-entity']);
            return of(null);
        })
    );
};
